module.exports = __webpack_public_path__ + "img/d123.f272c306.png";